import { Injectable } from '@angular/core';
import { ApiConfig} from '../_helpers/api-config'
import { AppSettings } from '../_helpers/app.settings';
import { Request } from '../_helpers/request';
import { HttpService } from '../shared/http.service';
import { HelperService } from '../_helpers/helper.service';
@Injectable({
  providedIn: 'root'
})
export class PricingService {
  pricingList: any = [];

  constructor(private http: HttpService,
    private helper: HelperService) { 
  }
  fetchPricing(param: any) {
    let req: Request = {
      method: AppSettings.HTTP_METHODS.POST,
      url: `${ApiConfig.fetchPricing}`,
      reqBody: param.data,
      success: param.success ? param.success : null,
      error: param.error ? param.error : null
    }
    this.http.sendRequest(req);
  }
  fetchAllPricingList(param: any) {
    let req: Request = {
      method: AppSettings.HTTP_METHODS.GET,
      url: `${ApiConfig.getPricingList}`,
      success: param.success ? param.success : null,
      error: param.error ? param.error : null
    }
    this.http.sendRequest(req);
  }
  createPricing(param: any) {
    let req: Request = {
        method: AppSettings.HTTP_METHODS.POST,
        url: `${ApiConfig.createPricing}`,
        reqBody: param.data,
        success: param.success ? param.success : null,
        error: param.error ? param.error : null
      }
      this.http.sendRequest(req);
  }
  editPricing(param: any) {
    let req: Request = {
      method: AppSettings.HTTP_METHODS.POST,
      url: `${ApiConfig.updatePricing}`,
      reqBody: param.data,
      success: param.success ? param.success : null,
      error: param.error ? param.error : null
    }
    this.http.sendRequest(req);
  }
  deletePricing(param: any) {
    let req: Request = {
      method: AppSettings.HTTP_METHODS.DELETE,
      url: `${ApiConfig.deletePricing}${param.data.id}`,
      success: param.success ? param.success : null,
      error: param.error ? param.error : null
    }
    this.http.sendRequest(req);
  }
}
